import type { Challenge, Deal } from '../data/types';
import { deal as dealFrom } from '../data/exercises';
import { shortName, type Slot } from '../data/film';

/**
 * Deal from the film (core loop doc 20 §4): where an exercise's deck has a
 * key that means "a person" or "a place", the film's own piece is dealt into
 * it instead of a stranger from the deck, so Day 6 asks about Nightingale's
 * lighthouse and not about a four-hour layover. Everything else is dealt as
 * before. Nothing is dealt from a piece the person does not have.
 */
const KEY_SLOT: Record<string, Slot> = {
  character: 'someone', person: 'someone', subject: 'someone', star: 'someone', 'first name': 'someone',
  place: 'somewhere', situation: 'somewhere', location: 'somewhere', setting: 'somewhere',
};

export function dealFromFilm(challenge: Challenge, has: Partial<Record<Slot, string>>, avoid?: Deal): { deal: Deal; fromFilm: string[] } {
  const d = dealFrom(challenge, avoid);
  const fromFilm: string[] = [];
  for (const key of Object.keys(challenge.deck)) {
    const slot = KEY_SLOT[key];
    const piece = slot ? shortName(has[slot], 60) : undefined;
    if (piece) { d[key] = piece; fromFilm.push(key); }
  }
  return { deal: d, fromFilm };
}
